export { default } from './SplashScreen';
